import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { setLoading } from "../../reducer/auth/auth";
import { getMyGifts, isOk, messageOf } from "../../services/gift";
import GiftPaymentDue from "./components/GiftPaymentDue";
import GiftDecisionDue from "./components/GiftDecisionDue";
import "./gift.css";
import "./redeem.css";

// What each status means to the purchaser (never wording the medium sees).
export const GIFT_STATUS_LABELS = {
  active: "Waiting to be used",
  payment_pending: "Payment needed",
  awaiting_purchaser: "Your answer needed",
  withdrawn: "Cancelled",
  expired: "Expired",
  redeemed: "Used — gift complete",
  suspended: "On hold — contact VerySoul",
  disabled: "Not available",
};

export function GiftStatus({ status }) {
  return <span className={`vsr-status vsr-status-${status}`}>{GIFT_STATUS_LABELS[status] || status}</span>;
}

const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "";

export default function MyGifts() {
  const dispatch = useDispatch();
  const [gifts, setGifts] = useState(null);

  useEffect(() => {
    dispatch(setLoading(true));
    getMyGifts().then((res) => {
      dispatch(setLoading(false));
      if (isOk(res)) {
        setGifts(res.data.data);
      } else {
        setGifts([]);
        toast.error(messageOf(res, "Your gifts could not be loaded."));
      }
    });
  }, []);

  const awaitingPayment = (gifts || []).filter((gift) => gift.pending_payment);
  const awaitingAnswer = (gifts || []).filter((gift) => gift.decision);
  const replaceGift = (updated) => setGifts((gifts || []).map((gift) => (gift.gift_id === updated.gift_id ? updated : gift)));

  return (
    <div className="vsr-page vsr-inner">
      <div className="vsr-stack">
        <div className="vsr-page-head">
          <div>
            <h1 className="vsr-title vsr-title-left">My Gifts</h1>
            <p className="vsr-lead vsr-lead-left">The VerySoul Experiences you've given. Print, share or send a card any time.</p>
          </div>
          <Link className="vsr-btn" to="/give-a-gift" state={{ from: "/my-gifts" }}>
            Give a new gift
          </Link>
        </div>

        {awaitingPayment.map((gift) => (
          <GiftPaymentDue key={`due-${gift.gift_id}`} payment={gift.pending_payment} />
        ))}

        {awaitingAnswer.map((gift) => (
          <GiftDecisionDue key={`decide-${gift.gift_id}`} gift={gift} onAnswered={replaceGift} />
        ))}

        {gifts && gifts.length === 0 && (
          <div className="vsr-card vsr-empty-state">
            <span className="vsr-icon-badge" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <rect x="3" y="8" width="18" height="13" rx="2" />
                <path d="M12 8v13M3 12h18M12 8c-1.5-3-5-3.5-5-1.25S9.5 8 12 8zM12 8c1.5-3 5-3.5 5-1.25S14.5 8 12 8z" />
              </svg>
            </span>
            <h2>You haven't given any gifts yet</h2>
            <p className="vsr-muted">Give someone a private session with a VerySoul Verified Professional Medium.</p>
            <Link className="vsr-btn" to="/give-a-gift" state={{ from: "/my-gifts" }}>
              Give a VerySoul Experience
            </Link>
          </div>
        )}

        {gifts && gifts.length > 0 && (
          <div className="vsr-gift-grid">
            {gifts.map((gift) => (
              <article key={gift.gift_id} className={`vsr-card vsr-gift-tile ${gift.pending_payment || gift.decision ? "is-due" : ""}`}>
                <div className="vsr-gift-tile-top">
                  <GiftStatus status={gift.status} />
                  <span className="vsr-muted">{formatDate(gift.created_at)}</span>
                </div>
                <p className="vsr-gift-tile-label">Gift Code</p>
                <p className="vsr-gift-tile-code">{gift.code}</p>
                <p className="vsr-muted">
                  Covers a session up to{" "}
                  <b>
                    {gift.currency} {gift.max_price}
                  </b>
                </p>
                {gift.expires_at && (
                  <p className="vsr-muted">
                    {gift.status === "expired" ? "Expired " : "Valid until "}
                    {formatDate(gift.expires_at)}
                  </p>
                )}
                <div className="vsr-gift-tile-actions">
                  {gift.pending_payment && (
                    <a className="vsr-btn vsr-btn-sm" href={gift.pending_payment.pay_url}>
                      Pay now
                    </a>
                  )}
                  <Link className="vsr-btn vsr-btn-outline vsr-btn-sm" to={`/my-gifts/${gift.gift_id}`}>
                    View card
                  </Link>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
